import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "body" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = ["src"]

import ButtonToggle from '@/design-system/atoms/buttons/ButtonToggle.vue'
import AccordionText from '@/design-system/atoms/AccordionText.vue'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'
import { FormatOptions, formatter } from '../../formatter'
import InfoOverlay from '../InfoOverlay.vue'

type Props = {
  presentDetails: boolean
  hasDetails: boolean
  presentInfo: boolean
  information?: string
  color?: string
  isLoading: boolean
  showOnMapEnabled: boolean
  showOnMap: boolean
  kpi?: string | number
  imgSrc?: string
  format?: FormatOptions
}

type Emits = {
  (e: 'toggleDetails'): void
  (e: 'toggleShowOnMap'): void
  (e: 'closeInfo'): void
}


export default /*@__PURE__*/_defineComponent({
  __name: 'KPICardBody',
  props: {
    presentDetails: { type: Boolean },
    hasDetails: { type: Boolean },
    presentInfo: { type: Boolean },
    information: {},
    color: {},
    isLoading: { type: Boolean },
    showOnMapEnabled: { type: Boolean },
    showOnMap: { type: Boolean },
    kpi: {},
    imgSrc: {},
    format: {}
  },
  emits: ["toggleDetails", "toggleShowOnMap", "closeInfo"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "765bfd1b": (_ctx.color)
}))

const props = __props
const emits = __emit
const { t, locale } = useI18n()

const detailsTitle = computed(() => {
  return props.presentDetails
    ? t('dashboard__text__hide-details')
    : t('dashboard__text__show-details')
})

const showOnMapTitle = computed(() => {
  return props.showOnMap ? t('dashboard__text__hide-on-map') : t('dashboard__text__show-on-map')
})

const label = computed(() => {
  if (props.kpi === undefined) {
    return '-'
  }
  const options = props.format
  return options && typeof options === 'object' && typeof props.kpi === 'number'
    ? formatter(props.kpi, locale.value, options)
    : props.kpi
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(InfoOverlay, {
      "is-visible": _ctx.presentInfo,
      info: _ctx.information,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (emits('closeInfo')))
    }, null, 8, ["is-visible", "info"]),
    _createElementVNode("section", _hoisted_1, [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(PulseLoader, {
            key: 0,
            loading: true,
            color: "#3F46D6"
          }))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (!_ctx.imgSrc)
              ? (_openBlock(), _createElementBlock("h1", _hoisted_2, _toDisplayString(label.value), 1))
              : (_openBlock(), _createElementBlock("img", {
                  key: 1,
                  src: require(`@/design-system/assets/icons/${_ctx.imgSrc}`),
                  alt: "''"
                }, null, 8, _hoisted_3))
          ], 64))
    ]),
    (_ctx.hasDetails || _ctx.showOnMapEnabled)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["button-group", { 'button-group-singular': !_ctx.showOnMapEnabled }])
        }, [
          (_ctx.showOnMapEnabled)
            ? (_openBlock(), _createBlock(ButtonToggle, {
                key: 0,
                buttonText: showOnMapTitle.value,
                iconLeft: require('@/design-system/assets/icons/Icon-Eye-Small.svg'),
                size: 'extra-small',
                active: _ctx.showOnMap,
                onOnClicked: _cache[1] || (_cache[1] = ($event: any) => (emits('toggleShowOnMap')))
              }, null, 8, ["buttonText", "iconLeft", "active"]))
            : _createCommentVNode("", true),
          (_ctx.hasDetails)
            ? (_openBlock(), _createBlock(AccordionText, {
                key: 1,
                active: _ctx.presentDetails,
                size: 'extrasmall',
                accordionText: detailsTitle.value,
                onOnClicked: _cache[2] || (_cache[2] = ($event: any) => (emits('toggleDetails')))
              }, null, 8, ["active", "accordionText"]))
            : _createCommentVNode("", true)
        ], 2))
      : _createCommentVNode("", true)
  ], 64))
}
}

})